import React from 'react';

const CanyonIcon = (props) => {
  return (
    <img
      alt="Wąwóz"
      src="/static/images/icons/place_types/canyon.svg"
      {...props}
    />
  );
};

export default CanyonIcon;
